module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic7.1c919b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic7.png
// module id = 486
// module chunks = 1